const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div
  class="demo-container o-rhythm"
  style="max-width: 40rem; margin: 0 auto; padding: 0 1.25rem"
>
  <p>
    Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Nullam
    quis risus eget urna mollis ornare vel eu leo.
  </p>
  <div class="wp-block-group `);
                this.echo(this.env.getFilter('escape').traceableCallable(9, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                this.echo(`">
    <div class="wp-block-group__inner-container">
      <div class="wp-block-image is-style-rounded">
        <figure class="alignright size-full is-resized">
          <img
            src="https://cloudfour.com/wp-content/uploads/2018/05/cpe-icon.png"
            alt=""
            width="80"
            height="80"
          />
        </figure>
      </div>
      <blockquote class="wp-block-quote">
        <p>
          I can say with confidence that I’ve never worked with a more
          technically and thoroughly capable team. It’s very apparent that they
          love what they do and watching their work unfold is truly a joy.
        </p>
        <cite>Scott Henning, Marketing Director</cite>
      </blockquote>
      <p>One more element in this group.</p>
    </div>
  </div>
  <p>
    Etiam porta sem malesuada magna mollis euismod. Maecenas sed diam eget risus
    varius blandit sit amet non magna.
  </p>
</div>
`);
            }

            getTemplateName() {
                return `2512ddb98c3417175570bcb1c4ba01e6ecd61365b53c869e70d62d855e647995`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `2512ddb98c3417175570bcb1c4ba01e6ecd61365b53c869e70d62d855e647995`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '2512ddb98c3417175570bcb1c4ba01e6ecd61365b53c869e70d62d855e647995');

let template = env.loadTemplate('2512ddb98c3417175570bcb1c4ba01e6ecd61365b53c869e70d62d855e647995');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/group.twig", args: context }
     );
     return rendered;;
};